module.exports = __webpack_public_path__ + "img/img39.d12eae80.jpg";